import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Apps } from '../../interfaces/apps.interface';
import { NgClass, NgIf, NgTemplateOutlet } from '@angular/common';
import { Environment } from '../../interfaces/environment.interface';

@Component({
  selector: 'wm-libs-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  standalone: true,
  imports: [RouterLink, NgClass, NgIf, NgTemplateOutlet],
})
export class LogoComponent {
  @Input() isDarkMode: boolean | null = null;
  @Input() app!: Apps;
  @Input() env!: Environment;
}
